import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
// components
import Menu from '~/shared/components/Menu';
import MenuButton from '~/shared/components/MenuButton';
// constants
import {zoomInIcon, zoomOutIcon} from '~/constants/InlineSvgs';
import withRouter, {routerPropTypes} from '~/router/withRouter';

import './index.scss';

export const SLEEVE_VIEWS = [
  'R.Sleeve',
  'L.Sleeve',
  'Right Sleeve',
  'Left Sleeve'
];

export const printAreaText = additionalPrintArea => {
  if (!additionalPrintArea) return '';

  switch (additionalPrintArea) {
    case 'hood':
      return 'Sleeve & Hood Design';
    case 'sleeve':
      return 'Sleeve Design';
    case 'leg':
      return 'Leg Design';
  }
  return '';
};

const propTypes = {
  zoomIn: PropTypes.func.isRequired,
  actions: PropTypes.objectOf(PropTypes.func),
  additionalPrintArea: PropTypes.string,
  changeViews: PropTypes.arrayOf(PropTypes.shape(MenuButton.propTypes)),
  designIsBlank: PropTypes.bool,
  hasOverlay: PropTypes.bool,
  hasSleeveProductImageIssue: PropTypes.bool,
  isEmbroidered: PropTypes.bool,
  isFundraisingMode: PropTypes.bool,
  isZoomed: PropTypes.bool,
  product: PropTypes.object,
  router: routerPropTypes,
  showOverlay: PropTypes.bool,
  sleevePrintEligible: PropTypes.bool,
  sleevePrintEnabled: PropTypes.bool,
  toggleOverlay: PropTypes.func
};

/** @extends {Component<PropTypes.InferProps<typeof propTypes>>} */
class CanvasToolbar extends PureComponent {
  static displayName = 'CanvasToolbar';
  static propTypes = propTypes;

  static defaultProps = {};

  disableOverlay = () => {
    this.props.toggleOverlay();
  };

  onClickAdditionalPrintAreaButton = () => {
    const {additionalPrintArea, product, router} = this.props;

    if (!product) return;

    return this.shouldShowSleevePrintOptIn()
      ? router.navigate('/sleevePrintPricing')
      : router.navigate(`/additionalPrintArea/${additionalPrintArea}`);
  };

  shouldShowSleevePrintOptIn = () => {
    const {changeViews, hasSleeveProductImageIssue, sleevePrintEligible} =
      this.props;
    if (hasSleeveProductImageIssue) return false;
    return sleevePrintEligible && changeViews?.length > 2;
  };

  renderChangeViews = () => {
    const {changeViews, hasSleeveProductImageIssue, sleevePrintEnabled} =
      this.props;

    if (changeViews.length < 1) {
      return null;
    }

    return changeViews.map(changeView => {
      if (
        SLEEVE_VIEWS.includes(changeView.text) &&
        (!sleevePrintEnabled || hasSleeveProductImageIssue)
      ) {
        return null;
      }

      const menuClasses = classnames('ndx-CanvasToolbar-menu', {
        'ndx-CanvasToolbar-menu--active': changeView.active
      });

      return (
        <Menu
          key={`ndx-CanvasToolbar-menu-${changeView.text}`}
          className={menuClasses}>
          <MenuButton
            key={`changeView-${changeView.text}`}
            className="ndx-CanvasToolbar-changeViewButton ndx-label4"
            {...changeView}
          />
        </Menu>
      );
    });
  };

  renderAreaText = () => {
    const {additionalPrintArea, isEmbroidered} = this.props;
    const additionalPrintAreaText = printAreaText(
      additionalPrintArea,
      isEmbroidered
    );

    if (!additionalPrintAreaText) return <></>;
    return (
      <Menu className="ndx-CanvasToolbar-menu">
        <MenuButton
          className="ndx-CanvasToolbar-printAreaButton ndx-label4"
          text={additionalPrintAreaText}
          onClick={this.onClickAdditionalPrintAreaButton}
        />
      </Menu>
    );
  };

  renderAdditionalPrintAreas = () => {
    const {additionalPrintArea, isFundraisingMode, sleevePrintEnabled} =
      this.props;

    const allowAdditionalPrintAreas = additionalPrintArea && !isFundraisingMode;

    if (
      (!this.shouldShowSleevePrintOptIn() && allowAdditionalPrintAreas) ||
      (this.shouldShowSleevePrintOptIn() && !sleevePrintEnabled)
    ) {
      return this.renderAreaText();
    }
  };

  render() {
    const {zoomIn, isZoomed} = this.props;
    const zoomIcon = isZoomed ? zoomOutIcon : zoomInIcon;

    return (
      <div className="ndx-CanvasToolbar u-clickPassThrough">
        <div className="ndx-CanvasToolbar-changeViews">
          {this.renderChangeViews()}
        </div>
        {this.renderAdditionalPrintAreas()}
        <Menu className="ndx-CanvasToolbar-menu ndx-CanvasToolbar-zoom">
          <MenuButton
            key="Zoom"
            className="ndx-CanvasToolbar-toolButton ndx-CanvasToolbar-zoomButton ndx-label4"
            icon={zoomIcon}
            text="Zoom"
            onClick={zoomIn}
          />
        </Menu>
        {this.props.hasOverlay && (
          <Menu className="ndx-CanvasToolbar-menu ndx-CanvasToolbar-Overlay">
            <MenuButton
              key="DisableOverlay"
              className="ndx-CanvasToolbar-toolButton ndx-label4"
              text={`${this.props.showOverlay ? 'Hide' : 'Show'} Hands`}
              onClick={this.disableOverlay}
            />
          </Menu>
        )}
        <div className="ndx-CanvasToolbar-footer u-clickPassThrough" />
      </div>
    );
  }
}

export default withRouter(CanvasToolbar);
